import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { UserProfile } from 'src/app/core/models/user';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ItemIdModel } from './../../../core/models/filter-model/item-id-model';
import { RegulationDetail } from 'src/app/core/models/regulation/regulation-detail';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { RegulationColumnModel } from 'src/app/core/models/regulation/regulation-close-status-model';
import { RegulationService } from 'src/app/core/services/regulation';
import { FileType } from 'src/app/core/enums/user/file-type';
import { CloseEvidanceDocumentModel } from 'src/app/core/models/regulation/close-Evidance-document-model';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { bulkcloseEvidanceInputModel, closeEvidanceInputModel } from 'src/app/core/models/regulation/close-evidance-input-model';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-bulk-close-dialog',
  templateUrl: './bulk-close-dialog.component.html',
  styleUrls: ['./bulk-close-dialog.component.scss']
})
export class BulkCloseDialogComponent implements OnInit {

  regulationDetails: RegulationDetail;
  user: UserProfile;
  toastModel: ToastViewModel;
  isToastShow = false;

  searchedJuris: ItemIdModel[] = [];
  selectedJuris: ItemIdModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  closeStatusList:Array<RegulationColumnModel>=[];
  impactAssessmentDocument: Array<CloseEvidanceDocumentModel>;
  isAssessmentLoader = false;
  isFileExist:boolean=false;
  isAssessmentLastEdited = false;
  isLoading = false;
  closeEvidanceInput!: bulkcloseEvidanceInputModel;
  @ViewChild('myFileInput') myFileInput:any;

  constructor(
    public dialogRef: MatDialogRef<BulkCloseDialogComponent>,
    private sessionService: SessionService,
    private userService: UserManagementService,
    private regulationService: RegulationService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public linkedIds: Array<number>,
    private _globalService: GlobalService
  ) {
    this.regulationDetails = new RegulationDetail();
    this.user = new UserProfile();
    this.toastModel = new ToastViewModel();
    this.impactAssessmentDocument = [];
    this.getRegulationStatusList();
  }

  ngOnInit(): void {
    this.fetchUserProfile();
  }

  async fetchUserProfile() {
    this.user = await this._globalService.getLoginUserData();
    if (this.user && this.user.userId > 0) {
      this.fetchJurisdiction();
    }
    // this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
    //   this.user = user;
    //   if (this.user && this.user.userId > 0) {
    //     this.fetchJurisdiction();
    //   }
    // });
  }
  getRegulationStatusList(): void {
    this.regulationService.getRegulationStatus().subscribe((result: RegulationColumnModel[]) => {
      this.closeStatusList=result;
    });
  }

  closeDialog(): void {
    if (this.selectedJuris.length === 0) {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = 'Please select a jurisdiction';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
    } else {
      if(this.regulationDetails.status==0){
        this.toastModel.Title = 'Warning';
        this.toastModel.Type = 'warning';
        this.toastModel.Message = 'Please select a status';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 3000);          
      } else {
        this.regulationDetails.jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
        this.dialogRef.close(this.regulationDetails);
      }
    }
  }

  fetchJurisdiction(): void {
    this.userService.getUserJurisdictions().subscribe((result: ItemIdModel[]) => {
      this.searchedJuris = result;
      let searchedId = localStorage.getItem('selectedDivision');
      if (this.searchedJuris && this.searchedJuris.length > 0) {
        if(searchedId){
          var filterDivision=this.searchedJuris.filter(s => s.id.toString()==searchedId);
          if(filterDivision && filterDivision.length>0){
            this.selectedJuris.push(filterDivision[0]);
          }
        }
        else{
          this.selectedJuris.push(this.searchedJuris[0]);
        }
      }
      this.fetchCloseEvidanceDocuments();
    });
  }
  uploadEvidenceAssessment(): void {
    if(this.selectedJuris.length>0){
      const fileInput = document.getElementById('uploadEviAssessment') as HTMLElement;
      fileInput.click();
    }
    else{
      this.imageAlertMessage('warning', "Please select a division!");
    }
  }
  handleFileInput(files: FileList): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.Assessment);
    }
    this.myFileInput.nativeElement.value = '';
  }
  uploadFileToActivity(fileToUpload: any, fileType: FileType): void {
    let jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
    this.isAssessmentLoader = true;
    const Ids=this.linkedIds.toString();
    this.regulationService.uploadEvidenceForBulkClose(fileToUpload, fileType, Ids,jurisdiction).subscribe((data: any) => {
      this.fetchCloseEvidanceDocuments(fileType);
      this.updateSectionLastEdited('Assessment');
    }, (err: HttpErrorResponse) => {
      this.isAssessmentLoader = false;
      this.imageAlertMessage('warning', 'File not uploaded, please check your file');
      setTimeout(() => {
      }, 1000);
    });
  }
  fetchCloseEvidanceDocuments(fileType?: FileType): void {
    this.isAssessmentLoader = true;
    let jurisdiction = MasterHelper.getStringFromObjectArray(this.selectedJuris);
    const Ids=this.linkedIds.toString()
    this.regulationService.getImpactAssessmentDocuments( Ids, jurisdiction).subscribe((result: CloseEvidanceDocumentModel[]) => {
      this.impactAssessmentDocument = result;
      if(this.impactAssessmentDocument.length>0){
        this.isFileExist=true;
      }
      this.isAssessmentLoader = false;
    });
  }

  updateSectionLastEdited(filter: string): void {
    this.isAssessmentLastEdited = true;
  }
  downloadDocument(id: number, fileName: string, extension: string, fileType: string,fileUrl:string): void {
    this.isAssessmentLoader = true;
    this.regulationDetails.FileName=fileName;
    this.regulationDetails.FileExtension=extension;
    this.regulationDetails.FileType=fileType;
    this.regulationDetails.FileUrl=fileUrl;
    this.regulationService.downloadEvidence(this.regulationDetails.regulationId,this.regulationDetails)
      .subscribe((data: any) => {
        this.isAssessmentLoader = false;
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `${fileName}${extension}`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }
  openDeleteModel(id: number, jurisdictionId:number,fileType: string, extension: string,fileName: string,fileUrl:string): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.removeCloseEvidanceDocuments(id, fileType,extension,fileName,fileUrl,jurisdictionId);
      }
    });
  }
  removeCloseEvidanceDocuments(id: number, fileType: string,extension: string,fileName: string,fileUrl:string,jurisdictionId:number): void {
    this.isAssessmentLoader = true;
    const Ids=this.linkedIds.toString();
    if(this.impactAssessmentDocument.length>0){
      this.closeEvidanceInput={FileExtension:extension,FileName:fileName,FileUrl:fileUrl,FileType:"1",Id:Ids,JurisdictionId:jurisdictionId};
    }
    this.regulationService.DeleteBulkCloseEvidenceDocument(id,this.closeEvidanceInput).subscribe((data: any) => {
      this.isAssessmentLoader = false;
      this.fetchCloseEvidanceDocuments(FileType.Assessment);
      if (data.result) {
        this.imageAlertMessage('success', data.result);
      }
    });
  }
  imageAlertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }
  onChange(){
    if(this.selectedJuris.length>0){
      this.fetchCloseEvidanceDocuments();
    }
    else{
      this.impactAssessmentDocument =[];
    }
  }

}
